export const BLOG_LABEL = 'Pickleball Hub';
export const MEME_SLUG = 'meme';
export const MEME_SUBCATEGORY_SLUG = 'memes';

export const pickleballPlaceholderImage = `https://images.pickleball.com/global/PB-gray.svg`;
export const clubsPlaceholderImage = `https://images.pickleball.com/global/PC-gray.svg`;
export const leaguesPlaceholderImage = `https://images.pickleball.com/global/PL-gray.svg`;
export const tournamentPlaceholderImage = `https://images.pickleball.com/global/PT-gray.svg`;
export const teamLeaguesPlaceholderImage = `https://images.pickleball.com/global/PTL-gray.svg`;
export const wprPlaceholderImage = `https://images.pickleball.com/global/WPR-gray.svg`;
